import Vue from 'vue';
// Import from `vuetify/lib` for modular tree-shaking
// See https://vuetifyjs.com/en/framework/a-la-carte
import Vuetify from 'vuetify/lib';
import theme from '@src/theme/theme.js';
import icons from '@src/theme/icons.js';
import '@stylus/index.styl';

Vue.use(Vuetify, {
    theme,
    icons,
});
